import { memo } from 'react';
import { Globe } from 'lucide-react';

import type { Tool } from '@/types/tool.type';

type Props = {
  tool: Tool;
  isSelected: boolean;
  onSelect: (tool: Tool) => void;
};

function ToolTypeIcon() {
  return <Globe className="h-4 w-4 text-primary-foreground" />;
}

export const ToolSidebarItem = memo(function ToolSidebarItem({
  tool,
  isSelected,
  onSelect,
}: Props) {
  return (
    <button
      type="button"
      onClick={() => onSelect(tool)}
      className={`flex w-full cursor-pointer items-center gap-3 border-b px-3 py-3.5 text-left transition-colors ${
        isSelected ? 'bg-muted/50' : 'hover:bg-muted/30'
      }`}
    >
      <div className="flex-shrink-0">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary">
          <ToolTypeIcon />
        </div>
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <p className="flex-1 truncate text-sm font-medium">{tool.name}</p>
          <span
            className={`h-1.5 w-1.5 shrink-0 rounded-full ${
              tool.enabled ? 'bg-green-500' : 'bg-muted-foreground/40'
            }`}
          />
        </div>

        <p className="mt-0.5 truncate text-xs text-muted-foreground">{tool.description}</p>
      </div>
    </button>
  );
});
